import { connect } from "react-redux";
import SaveDealerCase from "./Save";
import { bindActionCreators } from "redux";
import {documentUploadUrlPublic} from 'services/redux/fileUpload/action';
import {
    addCaseRequest,
    carBrandRequest,
    carModelRequest,
    carVariantRequest,
    bankListRequest,
    newBankDetailsRequest,
    vehicleDetailsRequest
} from "../../../../../services/redux/CarLoan/action";
const mapStateToProps = (state) => ({
    addCaseResponse : state.CarLoan.addCaseResponse,
    carBrandResponse : state.CarLoan.carBrandResponse,
    carModelResponse : state.CarLoan.carModelResponse,
    carVariantResponse : state.CarLoan.carVariantResponse,
    bankListResponse : state.CarLoan.bankListResponse,
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
    newBankDetailsResponse : state.CarLoan.newBankDetailsResponse,
    vehicleDetailsResponse : state.CarLoan.vehicleDetailsResponse,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({
        documentUploadUrlPublic,
        addCaseRequest,
        carBrandRequest,
        carModelRequest,
        carVariantRequest,
        bankListRequest,
        newBankDetailsRequest,
        vehicleDetailsRequest
    }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(SaveDealerCase);